

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */
/* global wizdata */

//warning!! this file is also shared and used inside demo page, see uniwizard-lib.js
//be careful when changing
import 'jquery';

import { getTranslator } from '../js/i18n';
import tools from '../js/tools';
import MouseHandler from './mouse';
import utils from './utils';
import WacomExtHandler from './wacom-ext';
import WacomHandler from './wgsstu';
import { useGuiHelper } from './wizard-gui-helper';

const t = getTranslator();

export function SignatureForm() {
}
SignatureForm.prototype = {
    img: null,
    canvas: null,
    ctx: null,
    bitmapurl: null,
    cb: null,
    handler1: null,
    handler2: null,
    wndData: null,
    bioDeviceMask: null,
    selectDeviceFn: null,
    _guiHelper: null,
    //default
    colorName: '#0000B4',
    cleanupEventListeners: null,

    prepare(cb) {
        cb();
    },
    connect(formData, cb) {
        //supports both promise and non-promise api
        //for new async Wacom implementation and old sync Wacom/Mouse
        const self = this;
        self.img = formData.img;
        self.canvas = formData.canvas;
        const signatureContainerBox = formData.signatureContainerBox;
        self.ctx = self.canvas.getContext('2d');
        self.bitmapurl = formData.bitmapurl;
        self.bioDeviceMask = formData.bioDeviceMask;
        if(!self.bioDeviceMask)
            self.bioDeviceMask = utils.FILTER_ALL;
        self.selectDeviceFn = formData.selectDevice;
        self.cb = cb;
        self.cleanupEventListeners = [];

        const wizardListener = formData.wizardListener;
        self._guiHelper = useGuiHelper(wizardListener);

        const redValue = wizdata.handsignPenColor[0];
        const greenValue = wizdata.handsignPenColor[1];
        const blueValue = wizdata.handsignPenColor[2];
        const color = ((redValue & 0xff) << 16) | ((greenValue & 0xff) << 8) | (blueValue & 0xff);
        this.colorName = '#' + ('000000' + color.toString(16)).slice(-6);

        const maxPenWidth = wizdata.handsignPreviewPenWidth[1];
        const minPenWidth = wizdata.handsignPreviewPenWidth[0];
        const diffPenWidth = maxPenWidth - minPenWidth;
        //1.5 by default
        const averageThickness = minPenWidth + (diffPenWidth / 2);

        let needMouseButtons = false;
        let initializing = false;
        let initialized = false;
        let lastError = null;
        self._guiHelper.waiting2(true);
        Promise.resolve()
            .then(() => {
                //first try new Wacom
                if(initialized)
                    return undefined;
                if(!(self.bioDeviceMask & utils.FILTER_WACOM_EXT))
                    return undefined;
                initializing = true;
                self.handler1 = new WacomExtHandler(self, self._guiHelper);
                return self.handler1.init({
                    penColor: self.colorName,
                    averageThickness,
                });
            })
            .then(() => {
                if(initializing) {
                    needMouseButtons = true;
                    //for mouse buttons
                    self.bioDeviceMask |= (utils.FILTER_MOUSE | utils.FILTER_TOUCH);
                    initializing = false;
                    initialized = true;
                }
            })
            .catch((err) => {
                lastError = err;
                initializing = false;
            })
            .then(() => {
                //next try old Wacom
                if(initialized)
                    return undefined;
                if(!(self.bioDeviceMask & utils.FILTER_WACOM))
                    return undefined;
                initializing = true;
                self.handler1 = new WacomHandler(self);
                return self.handler1.init();
            })
            .then(() => {
                if(initializing) {
                    needMouseButtons = true;
                    //for mouse buttons
                    self.bioDeviceMask |= (utils.FILTER_MOUSE | utils.FILTER_TOUCH);
                    initializing = false;
                    initialized = true;
                }
            })
            .catch((err) => {
                lastError = err;
                initializing = false;
            })
            .then(() => {
                //last try mouse
                if(initialized)
                    return undefined;
                if(!(self.bioDeviceMask & utils.FILTER_POINTER_ALL_INTERNAL))
                    return undefined;
                initializing = true;
                self.handler1 = new MouseHandler(self, false);
                return self.handler1.init();
            })
            .then(() => {
                if(initializing) {
                    initializing = false;
                    initialized = true;
                }
            })
            .catch((err) => {
                lastError = err;
                initializing = false;
            })
            .then(() => {
                if(!initialized)
                    return Promise.reject(lastError || new Error(t('biosign.no_devices')));
                return self.handler1.connect();
            })
            .then(() => {
                if(needMouseButtons) {
                    return Promise.resolve()
                        .then(() => {
                            self.handler2 = new MouseHandler(self, true);
                        })
                        .then(() => self.handler2.init())
                        .then(() => self.handler2.connect());
                }
                return Promise.resolve();
            })
            .then(() => self.handler1.clearScreen(true))
            .then(() => {
                if(self.handler2) {
                    return self.handler2.clearScreen(true);
                }
                return undefined;
            })
            .then(() => {
                function handleKeyDown(e) {
                    const key = e.key || e.keyCode;
                    if(key === 'Escape' || key === 'Esc' || key === 27) {
                        self.btnCancel_Click();
                    } else if(key === 'Enter' || key === 13) {
                        self.btnOk_Click();
                    } else if(key === 'Backspace' || key === 8) {
                        self.btnClear_Click();
                    } else if(key === 'Delete' || key === 'Del' || key === 46) {
                        self.btnClear_Click();
                    }
                }
                signatureContainerBox.addEventListener('keydown', handleKeyDown);
                this.cleanupEventListeners.push(function() {
                    signatureContainerBox.removeEventListener('keydown', handleKeyDown);
                });
            })
            .then(() => {
                self._guiHelper.waiting2(false);
            })
            .catch((err) => {
                Promise.resolve()
                    .then(() => {
                        if(initialized) {
                            return self.closeAll();
                        }
                        return undefined;
                    })
                    .then(() => {
                        self._guiHelper.waiting2(false);
                        if(err.pluginDiagnostic) {
                            err.pluginDiagnostic.showDiagnostic(self._guiHelper);
                        }
                        cb(err);
                    });
            });
    },
    createModalWindow(isHorizontal) {
        const _dr = this;
        if(_dr.wndData)
            return _dr.wndData;

        const buttons = new utils.Buttons();
        buttons.add({
            text: t('common.ok'),
            image: 'ok',
            click() {
                _dr.btnOk_Click();
            },
        });
        buttons.add({
            text: t('biosign.clear'),
            image: 'clear',
            click() {
                _dr.btnClear_Click();
            },
        });
        buttons.add({
            text: t('common.cancel'),
            image: 'cancel',
            click() {
                _dr.btnCancel_Click();
            },
        });

        const width = _dr.canvas.clientWidth;
        const height = _dr.canvas.clientHeight;
        const btns = buttons.construct(width, height, isHorizontal);

        const imgparams = {
            width,
            height,
            isHorizontal,
            buttons: btns,
        };
        const imageUrl = new utils.ImageUrl(_dr.bitmapurl, imgparams);
        _dr.wndData = {
            btns,
            width,
            height,
            ctx: _dr.ctx,
            imageUrl,
            bioDeviceMask: _dr.bioDeviceMask,
        };

        const imgurl = imageUrl.construct({ format: 'png', type: 'image', transparent: true });
        _dr.img.src = imgurl;
        return _dr.wndData;
    },

    clearImage() {
        const ctx = this.ctx;
        const width = this.wndData.width;
        const height = this.wndData.height;
        ctx.clearRect(0, 0, width, height);
    },

    selectDevice(handler, device) {
        if(!this.selectDeviceFn || (handler != this.handler1))
            return;
        this.selectDeviceFn(device);
    },
    btnOk_Click() {
        Promise.resolve()
            .then(() => this.handler1.makeSignatureData())
            .then((signData) => this.finishSignature(signData))
            .catch((err) => { tools.scripterr(err); });
    },
    btnClear_Click() {
        Promise.resolve()
            .then(() => this.clearImage())
            .then(() => this.handler1.clearScreen())
            .then(() => {
                if(this.handler2)
                    return this.handler2.clearScreen();
                return undefined;
            })
            .catch((err) => { tools.scripterr(err); });
    },
    btnCancel_Click() {
        this.finishSignature(null);
    },
    closeAll() {
        return Promise.resolve()
            .then(() => this.handler1.close())
            .catch(() => { /**/ })
            .then(() => {
                if(this.handler2)
                    return this.handler2.close();
                return undefined;
            })
            .catch(() => { /**/ })
            .then(() => {
                if(this.cleanupEventListeners) {
                    this.cleanupEventListeners.forEach((listener) => {
                        try { listener(); } catch(e) { /**/ }
                    });
                    this.cleanupEventListeners = [];
                }
            })
            .catch(() => { /**/ });
    },
    finishSignature(signData) {
        return Promise.resolve()
            .then(() => this.closeAll())
            .then(() => this.cb(null, signData));
    },
    onPenData(prev, pt, pressure) {
        if(pressure == 0)
            return;
        const maxPenWidth = wizdata.handsignPreviewPenWidth[1];
        const minPenWidth = wizdata.handsignPreviewPenWidth[0];
        const diffPenWidth = maxPenWidth - minPenWidth;
        const strokeThickness = minPenWidth + diffPenWidth * pressure;

        const ctx = this.ctx;
        ctx.strokeStyle = this.colorName;
        ctx.lineWidth = strokeThickness;
        ctx.beginPath();
        ctx.moveTo(prev.x, prev.y);
        ctx.lineTo(pt.x, pt.y);
        ctx.closePath();
        ctx.stroke();
    },
};
